import React from "react";

const Button = (props) => {
  return <button className={`${props.className} border-4 border-neon border-dashed px-12 py-3 text-neon flex items-center z-10`}>{props.text}</button>;
};

export default Button;
